import { useQuery } from '@tanstack/react-query';
import { fetchRoute, RouteDto } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useRoute = (args: { id: number }) =>
  useQuery({
    queryFn: async () => {
      const response = await extractData(
        fetchRoute({
          path: { id: args.id },
        })
      );
      return response.route as RouteDto & { id: number; name: string };
    },
    queryKey: ['routes', args.id],
  });
